var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsazul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.018 17.4582C5.5105 17.4582 5.17217 17.1198 5.17217 16.6123V14.0748H1.78883C0.858418 14.0748 0.097168 13.3136 0.097168 12.3832V2.23317C0.097168 1.30275 0.858418 0.541504 1.78883 0.541504H15.3222C16.2526 0.541504 17.0138 1.30275 17.0138 2.23317V12.3832C17.0138 13.3136 16.2526 14.0748 15.3222 14.0748H10.1626L7.033 17.2044C6.86384 17.3736 6.69467 17.4582 6.44092 17.4582H6.018ZM9.40134 8.154V3.079H7.70967V8.154M9.40134 11.5373V9.84567H7.70967V11.5373H9.40134Z",
    fill: "#0F0742"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsazul);
export default __webpack_public_path__ + "static/media/detailsazul.cf67095eed38a8c74be73bcd31e3268a.svg";
export { ForwardRef as ReactComponent };